<script setup lang="ts">
import { useSidebar } from "@/components/ui/sidebar";

const { open: isSidebarOpen } = useSidebar();
</script>

<template>
  <img
    v-if="$page.props.logo && isSidebarOpen"
    :src="$page.props.logo"
    alt="logo"
  />
</template>
